import { colors, typography } from '@insurancemenu/imenu-components-lib';
import styled from 'styled-components';

export const TitleStyled = styled.h3`
  ${typography.capsRegular[14]};
  color: ${colors.neutral[700]};
  border-bottom: 0.1rem solid ${colors.neutral[300]};
  padding-bottom: 1rem;
  margin: 0 0 2rem;

  /* Useful when the title is inside an IMForm */
  width: 100%;
`;
